import * as FaIcons from 'react-icons/fa';

// Configuración centralizada de todos los mantenedores
export const MANTENEDORES_CONFIG = {
  cierre: {
    id: 'cierre',
    titulo: 'Cierres de Conductores',
    descripcion: 'Gestión de cierres de conductores y sus estados',
    icon: <FaIcons.FaCoins />,
    color: '#008500',
    path: '/mantenedores/cierre',
    emails: [], // Sin restricciones - acceso libre
    config: {
      apiEndpoint: '/api/cierre',
      title: 'Cierres de Conductores',
      searchPlaceholder: 'Buscar cierres...',
      // Configuración pendiente
    }
  },

  directorio: {
    id: 'directorio',
    titulo: 'Directorio',
    descripcion: 'Gestión de conductores y su información',
    icon: <FaIcons.FaIdCard />,
    color: '#667eea',
    path: '/mantenedores/directorio',
    emails: [],
    // Configuración específica del mantenedor
    config: {
      apiEndpoint: '/api/directorio',
      title: 'Directorio de Conductores',
      searchPlaceholder: 'Buscar por nombre, RUT o email...'
    }
  },
  
  empresas: {
    id: 'empresas',
    titulo: 'Empresas',
    descripcion: 'Administración de empresas de los conductores',
    icon: <FaIcons.FaBuilding />,
    color: '#48bb78',
    path: '/mantenedores/empresas',
    emails: [],
    config: {
      apiEndpoint: '/api/empresas',
      title: 'Gestión de Empresas',
      searchPlaceholder: 'Buscar por nombre o RUT de empresa...',
      // Configuración pendiente
    }
  },
  
  'estados': {
    id: 'estados',
    titulo: 'Estados y Sub Estados',
    descripcion: 'Configuración de estados y sub estados',
    icon: <FaIcons.FaTasks />,
    color: '#ed8936',
    path: '/mantenedores/estados',
    emails: [],
    config: {
      apiEndpoint: '/api/estados',
      title: 'Estados y Sub Estados',
      searchPlaceholder: 'Buscar estados...',
      // Configuración pendiente
    }
  },
  
  extras: {
    id: 'extras',
    titulo: 'Extras',
    descripcion: 'Bonos, descuentos y otros beneficios',
    icon: <FaIcons.FaGift />,
    color: '#e53e3e',
    path: '/mantenedores/extras',
    emails: [],
    config: {
      apiEndpoint: '/api/extras',
      title: 'Gestión de Extras',
      searchPlaceholder: 'Buscar extras...',
      // Configuración pendiente
    }
  },
  
  rutas: {
    id: 'rutas',
    titulo: 'Rutas de Conductores',
    descripcion: 'Gestión de rutas asignadas a conductores',
    icon: <FaIcons.FaRoute />,
    color: '#805ad5',
    path: '/mantenedores/rutas',
    emails: [],
    config: {
      apiEndpoint: '/api/rutas',
      title: 'Rutas de Conductores',
      searchPlaceholder: 'Buscar rutas...',
      // Configuración pendiente
    }
  },
  
  tarifarios: {
    id: 'tarifarios',
    titulo: 'Tarifarios',
    descripcion: 'Configuración de tarifas y precios',
    icon: <FaIcons.FaCalculator />,
    color: '#38b2ac',
    path: '/mantenedores/tarifarios',
    emails: [], // Sin restricciones - acceso libre
    config: {
      apiEndpoint: '/api/tarifarios',
      title: 'Gestión de Tarifarios',
      searchPlaceholder: 'Buscar tarifarios...',
      // Configuración pendiente
    }
  },
  
  usuarios: {
    id: 'usuarios',
    titulo: 'Usuarios',
    descripcion: 'Gestión de usuarios y permisos',
    icon: <FaIcons.FaUsers />,
    color: '#3182ce',
    path: '/mantenedores/usuarios',
    emails: [],
    config: {
      apiEndpoint: '/api/usuarios',
      title: 'Gestión de Usuarios',
      searchPlaceholder: 'Buscar usuarios...',
      // Configuración pendiente
    }
  },
  
  // Componente temporal de prueba
  testUsuario: {
    id: 'test-usuario',
    titulo: 'Test Usuario (Debug)',
    descripcion: 'Prueba de API de usuarios con estructura ControlGestion',
    icon: <FaIcons.FaBug />,
    color: '#e53e3e',
    path: '/mantenedores/test-usuario',
    emails: [],
    config: {
      apiEndpoint: '/api/usuarios',
      title: 'Test Usuario - Debug',
      searchPlaceholder: 'Testing...',
    }
  },
  
  generales: {
    id: 'generales',
    titulo: 'Generales',
    descripcion: 'Configuraciones generales del sistema',
    icon: <FaIcons.FaCog />,
    color: '#718096',
    path: '/mantenedores/generales',
    emails: [],
    config: {
      apiEndpoint: '/api/generales',
      title: 'Configuraciones Generales',
      searchPlaceholder: 'Buscar configuraciones...',
      // Configuración pendiente
    }
  }
};

// Función para obtener la lista de mantenedores (para el dashboard)
export const getMantenedoresList = () => {
  return Object.values(MANTENEDORES_CONFIG);
};

// Función para obtener un mantenedor específico por ID
export const getMantenedorById = (id) => {
  return MANTENEDORES_CONFIG[id] || null;
};

// Función para verificar permisos centralizadamente
export const hasMantenedorPermission = (mantenedorId, userEmail) => {
  const mantenedor = getMantenedorById(mantenedorId);
  if (!mantenedor) return false;
  
  // Si el array de emails está vacío, cualquier usuario autenticado tiene acceso
  if (!mantenedor.emails || mantenedor.emails.length === 0) {
    return true;
  }
  
  // Si hay emails específicos, verificar si el usuario está en la lista
  return mantenedor.emails.includes(userEmail);
};

// Mapeo de IDs de mantenedores a nombres de módulos de la API
// Para el acceso general al módulo mantenedores, se verifica 'mantenedores'
// Para páginas específicas, se verifican los mantenedores individuales
export const MANTENEDOR_MODULES_MAP = {
  cierre: 'cierre',
  directorio: 'conductores',
  empresas: 'empresas',
  estados: 'estados_subestados',
  extras: 'extras',
  generales: 'mantenedores_generales',
  rutas: 'rutas',
  tarifarios: 'tarifarios',
  usuarios: 'usuarios',
  mantenedores: 'mantenedores' // acceso general al dashboard
};

// Función helper para obtener el nombre del módulo de un mantenedor
export const getMantenedorModule = (mantenedorId) => {
  return MANTENEDOR_MODULES_MAP[mantenedorId] || null;
};
